import { message } from 'ant-design-vue'

message.config({
  top: '0',
  duration: 3,
  maxCount: 3,
})

const success = (content, duration, onClose) => {
  message.success(content, duration, onClose)
}

const error = (...params) => {
  message.error(...params)
}

const info = (...params) => {
  message.info(...params)
}

const warn = (...params) => {
  message.warn(...params)
}

export default {
  success,
  error,
  info,
  warn,
  warning: warn,
}
